module.exports = __webpack_public_path__ + "img/formatpaintercursor.fca25beb.svg";